import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { COLORS } from "colors/color";
import React, { useState, useRef, useEffect } from "react";
import { CardBody, CardTitle, Col, Row } from "react-bootstrap";

function DashboardCards({ icon, title, number, tooltipText }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);

  return (
    <Grid item lg={3} md={6} sm={6}>
      <Card
        sx={{
          width: "100%",
          boxShadow: "none",
          maxWidth: { xs: '100%', sm: 358 },
          minWidth: { xs: '100%', sm: 150 },
          height: { xs: 120, sm: 140 },
          borderRadius: '20px',
          borderWidth: '1px',
          paddingTop: { xs: '12px', sm: '8px' },
          paddingBottom: { xs: '12px', sm: '18px' },
          paddingLeft: { xs: '16px', sm: '12px' },
          paddingRight: { xs: '16px', sm: '12px' },
          gap: '10px',
          border: '1px solid #D9D9D9',
          position: 'relative'
        }}
      >
        {tooltipText && (
          <Box
            ref={iconRef}
            sx={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              cursor: 'help',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#f5f5f5',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: '#e0e0e0',
              },
            }}
            onMouseEnter={() => {
              if (iconRef.current) {
                const rect = iconRef.current.getBoundingClientRect();
                setTooltipPosition({
                  top: rect.top - 10,
                  left: (rect.left + rect.width / 2) - 120
                });
              }
              setShowTooltip(true);
            }}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
              i
            </Typography>
            {showTooltip && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 'auto',
                  bottom: 'auto',
                  right: 'auto',
                  left: 'auto',
                  transform: 'translate(-50%, -100%)',
                  backgroundColor: 'rgba(0,0,0,0.9)',
                  color: 'white',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  fontSize: '13px',
                  lineHeight: '1.4',
                  maxWidth: '250px',
                  width: 'max-content',
                  whiteSpace: 'normal',
                  wordWrap: 'break-word',
                  zIndex: 9999,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  animation: 'fadeIn 0.2s ease-in-out',
                  pointerEvents: 'none',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    borderLeft: '5px solid transparent',
                    borderRight: '5px solid transparent',
                    borderTop: '5px solid rgba(0,0,0,0.9)',
                  }
                }}
                style={{
                  top: `${tooltipPosition.top}px`,
                  left: `${tooltipPosition.left}px`,
                }}
              >
                {tooltipText}
              </Box>
            )}
          </Box>
        )}
        <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    fontSize: { xs: '14px', sm: '16px' },
                    color: ' #00000080'
                  }}
                >
                  {title}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: { xs: '22px', sm: '26px' },
                    color: '#000000'
                  }}
                >
                  {number}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default DashboardCards;